export enum AlternativePurchaseParam {
  Token = 'purchaseToken',
  BundleId = 'purchaseBundleId',
}

export enum Step {
  Confirm = 'Confirm',
  Request = 'Request',
  Success = 'Success',
  Error = 'Error',
}
